import { useSelector } from 'react-redux';
import { RouteName } from '@mews-commander/enums';
import { getProductServiceOrder } from '@mews-commander/legacy-entities/src/ducks';
import { getService } from '@mews-commander/legacy-entities/src/ducks/services';
import { ApplicationState } from '@mews-commander/types';
import { Dash } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedProperty } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { Identifiable } from '@mews/std';
import { ModalLink } from './connected/Link';

export const ProductServiceOrderLink = ({ id }: Identifiable) => {
    const productServiceOrder = useSelector((state: ApplicationState) => getProductServiceOrder(state, { id }));
    const service = useSelector((state: ApplicationState) =>
        productServiceOrder ? getService(state, { id: productServiceOrder?.serviceId }) : null
    );
    const resolveRoute = useResolveRoute();

    if (!productServiceOrder || !service) return <Dash />;

    const url = resolveRoute(RouteName.ProductServiceOrderDetail, { id });

    return (
        <ModalLink data-service-order-link={id} url={url}>
            <LocalizedProperty property={service.names} />
            {UnicodeEntity.NoBreakSpace}
            {productServiceOrder.number}
        </ModalLink>
    );
};
